export const normalizeDocument = (document: string) => (
  document.replace(/[^0-9]/g, '')
);

export const normalizePasskey = (membershipName: string) => (
  membershipName.replace(/\s/g, '')
);
